<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-arrow-academy-yearbook">
<h1>The Arrow Academy Yearbook</h1>
<table style="width:97%;">
<colgroup>
<col width="51%"/>
<col width="45%"/>
</colgroup>
<thead>
<tr class="header">
<th align="left"><strong>Junior class</strong></th>
<th align="left"><strong>Upper class</strong></th>
</tr>
</thead>
<tbody>
<tr class="odd">
<td align="left">Adelaide Abbott<br/> 5<sup>th</sup> Grade<br/> Telekinesis</td>
<td align="left">Caroline James <br/>12<sup>th</sup> Grade<br/> Mind-Reading</td>
</tr>
<tr class="odd">
<td align="left"></td>
<td align="left"></td>
</tr>
<tr class="even">
<td align="left">Brooklynn Black<br/>10th Grade<br/> Mind-reading</td>
<td align="left">Henry Miller<br/>11<sup>th</sup> Grade<br/> Telekinesis</td>
</tr>
<tr class="even">
<td align="left"></td>
<td align="left"></td>
</tr>
<tr class="odd">
<td align="left">Dylann Robins<br/>5<sup>th</sup> Grade<br/>Shape shifting</td>
<td align="left">Jay Robinson<br/> 12<sup>th</sup> Grade<br/> Shape shifting</td>
</tr>
<tr class="odd">
<td align="left"></td>
<td align="left"></td>
</tr>
<tr class="even">
<td align="left">Ian Royce<br/>5<sup>th</sup> Grade <br/>Speed</td>
<td align="left">Katherine Cameron <br/>12<sup>th</sup> Grade<br/>Healing</td>
</tr>
<tr class="even">
<td align="left"></td>
<td align="left"></td>
</tr>
<tr class="odd">
<td align="left">Isaac Abbott<br/> 9<sup>th</sup> Grade<br/>Healing</td>
<td align="left">Levi Smith<br/> 11<sup>th</sup> Grade<br/>Invisibility</td>
</tr>
<tr class="odd">
<td align="left"></td>
<td align="left"></td>
</tr>
<tr class="even">
<td align="left">Jensen Mayers<br/>3<sup>rd</sup> Grade<br/>Invisibility</td>
<td align="left">Reid Johnson<br/>11<sup>th</sup> Grade<br/>Strength</td>
</tr>
<tr class="even">
<td align="left"></td>
<td align="left"></td>
</tr>
<tr class="odd">
<td align="left">Lincoln Ridge<br/>4<sup>th</sup> Grade<br/>Strength</td>
<td align="left">Timothy Keller<br/>12<sup>th</sup> Grade<br/>Flight</td>
</tr>
<tr class="odd">
<td align="left"></td>
<td align="left"></td>
</tr>
<tr class="even">
<td align="left">Silas Jones<br/>6<sup>th</sup> Grade<br/>Flight</td>
<td align="left">Wendy Cortez<br/>11<sup>th</sup> Grade<br/>Flight</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?017e7538